import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth/auth.guard';
import { SuperAdminGuard } from './core/guards/super-admin/super-admin.guard';

const routes: Routes = [
  {
    path: 'admin',
    children: [
      {
        path: 'auth',
        canActivate: [AuthGuard],
        loadChildren: () => import('./features/auth/auth.module').then(m => m.AuthModule)
      },
      {
        path: '',
        canActivate: [SuperAdminGuard],
        loadChildren: () => import('./features/super-admin/super-admin.module').then(m => m.SuperAdminModule)
      }
    ]
  },
  {
    path: ':tenantSlug',
    loadChildren: () => import('./features/private/private.module').then(m => m.PrivateModule),
  },
  {
    path: '',
    redirectTo: 'admin/auth/login',
    pathMatch: 'full'
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
